export const MESSAGE_CENTER = {
    GET_RECIPIENT_GROUP: 'GET_RECIPIENT_GROUP',
    GET_RECIPIENT_GROUP_SUCCESS: 'GET_RECIPIENT_GROUP_SUCCESS',
    GET_RECIPIENT_GROUP_FAIL: 'GET_RECIPIENT_GROUP_FAIL',

    GET_DISABLE_OPTION: 'GET_DISABLE_OPTION',
    GET_DISABLE_OPTION_SUCCESS: 'GET_DISABLE_OPTION_SUCCESS',
    GET_DISABLE_OPTION_FAIL: 'GET_DISABLE_OPTION_FAIL',

    GET_RECIPIENTS_ALL: 'GET_RECIPIENTS_ALL',
    GET_RECIPIENTS_ALL_SUCCESS: 'GET_RECIPIENTS_ALL_SUCCESS',
    GET_RECIPIENTS_ALL_FAIL: 'GET_RECIPIENTS_ALL_FAIL',

    GET_MESSAGE_TYPES: 'GET_MESSAGE_TYPES',
    GET_MESSAGE_TYPES_SUCCESS: 'GET_MESSAGE_TYPES_SUCCESS',
    GET_MESSAGE_TYPES_FAIL: 'GET_MESSAGE_TYPES_FAIL',

    GET_RECIPIENTS: 'GET_RECIPIENTS',
    GET_RECIPIENTS_SUCCESS: 'GET_RECIPIENTS_SUCCESS',
    GET_RECIPIENTS_FAIL: 'GET_RECIPIENTS_FAIL',

    GET_MESSAGES_GENERAL: 'GET_MESSAGES_GENERAL',
    GET_MESSAGES_GENERAL_SUCCESS: 'GET_MESSAGES_GENERAL_SUCCESS',
    GET_MESSAGES_GENERAL_FAIL: 'GET_MESSAGES_GENERAL_FAIL',

    GET_RATIO: 'GET_RATIO',
    GET_RATIO_SUCCESS: 'GET_RATIO_SUCCESS',
    GET_RATIO_FAIL: 'GET_RATIO_FAIL',

    DELETE_MESSAGE: 'DELETE_MESSAGE',
    DELETE_MESSAGE_SUCCESS: 'DELETE_MESSAGE_SUCCESS',
    DELETE_MESSAGE_FAIL: 'DELETE_MESSAGE_FAIL',

    EDIT_MESSAGE: 'EDIT_MESSAGE',
    EDIT_MESSAGE_SUCCESS: 'EDIT_MESSAGE_SUCCESS',
    EDIT_MESSAGE_FAIL: 'EDIT_MESSAGE_FAIL',

    CREATE_MESSAGE: 'CREATE_MESSAGE',
    CREATE_MESSAGE_SUCCESS: 'CREATE_MESSAGE_SUCCESS',
    CREATE_MESSAGE_FAIL: 'CREATE_MESSAGE_FAIL',

    GET_DRAFTS: 'GET_DRAFTS',
    GET_DRAFTS_SUCCESS: 'GET_DRAFTS_SUCCESS',
    GET_DRAFTS_FAIL: 'GET_DRAFTS_FAIL',

    GET_MESSAGES_GENERAL_HISTORY: 'GET_MESSAGES_GENERAL_HISTORY',
    GET_MESSAGES_GENERAL_HISTORY_SUCCESS: 'GET_MESSAGES_GENERAL_HISTORY_SUCCESS',
    GET_MESSAGES_GENERAL_HISTORY_FAIL: 'GET_MESSAGES_GENERAL_HISTORY_FAIL',

    GET_DRIVERS: 'GET_DRIVERS',
    GET_DRIVERS_SUCCESS: 'GET_DRIVERS_SUCCESS',
    GET_DRIVERS_FAIL: 'GET_DRIVERS_FAIL'
}